/**
 * Zone bounds, heightfields, collision.
 */
import { E, k } from "../math.js";

export const At = {
        x: 0,
        z: -150,
        yaw: 0
    };
export const jt = {
        x: 0,
        z: -15.5,
        yaw: 0
    };
export const H = {
        xMin: -46,
        xMax: 46,
        zMin: -182,
        zMax: -78
    };
export const U = {
        zStart: -78,
        zEnd: -18,
        radius: 3.4,
        centerY: 2.75,
        halfFloor: 1.95
    };
export const W = {
        xMin: -14,
        xMax: 14,
        zMin: -18,
        zMax: 16,
        height: 7.4
    };
export const G = {
        xMin: -3.3,
        xMax: 3.3,
        zMin: 4.3,
        zMax: 7.9,
        top: .9
    };
export const K = {
        xMin: -2.2,
        xMax: 2.2,
        zMin: 5.2,
        zMax: 6.3,
        top: 1.95
    };
export const Mt = {
        x: 0,
        y: G.top,
        z: 6.95,
        yaw: Math.PI
    };
export const Nt = {
        x: 0,
        y: 3,
        z: 6
    };
export const Pt = [{
        x: -9.5,
        z: -6,
        r: .6
    }, {
        x: 9.5,
        z: -6,
        r: .6
    }, {
        x: -9.5,
        z: 10,
        r: .6
    }, {
        x: 9.5,
        z: 10,
        r: .6
    }];
export const Ft = [{
        x: -4.6,
        z: 3.6,
        w: 1.2,
        d: 1.1,
        h: 2.6,
        yaw: Math.PI + .35
    }, {
        x: 4.6,
        z: 3.6,
        w: 1.2,
        d: 1.1,
        h: 2.6,
        yaw: Math.PI - .35
    }, {
        x: -4.6,
        z: 8.6,
        w: 1.2,
        d: 1.1,
        h: 2.6,
        yaw: -.35
    }, {
        x: 4.6,
        z: 8.6,
        w: 1.2,
        d: 1.1,
        h: 2.6,
        yaw: .35
    }];
export const q = [
        [0, -158],
        [0, -150],
        [-3.5, -140],
        [-6.5, -128],
        [-4, -116],
        [2.5, -104],
        [4, -94],
        [1.5, -86],
        [0, -79]
    ];
export const It = .32;
export const Lt = [...Ft.map(e => ({
        xMin: e.x - e.w / 2 - .05,
        xMax: e.x + e.w / 2 + .05,
        zMin: e.z - e.d / 2 - .05,
        zMax: e.z + e.d / 2 + .05,
        top: e.h
    })), {
        ...K
    }];

export function Rt(e) {
    return e < U.zStart ? `forest` : e < U.zEnd ? `pipe` : `club`
}

export function zt(e) {
    return {
        forest: e < U.zStart + 24,
        pipe: e > U.zStart - 30 && e < U.zEnd + 14,
        club: e > U.zEnd - 30
    }
}

export function Bt(e, t, n, r = 0) {
    return e >= n.xMin - r && e <= n.xMax + r && t >= n.zMin - r && t <= n.zMax + r
}

export function Vt(e, t) {
    let n = Math.imul(e, 374761393) + Math.imul(t, 668265263);
    return n = Math.imul(n ^ n >>> 13, 1274126177), ((n ^ n >>> 16) >>> 0) / 4294967296
}

export function Ht(e, t) {
    let n = Math.floor(e),
        r = Math.floor(t),
        i = e - n,
        a = t - r,
        o = i * i * (3 - 2 * i),
        s = a * a * (3 - 2 * a),
        c = Vt(n, r),
        l = Vt(n + 1, r),
        u = Vt(n, r + 1),
        d = Vt(n + 1, r + 1);
    return c + (l - c) * o + (u - c) * s + (c - l - u + d) * o * s
}
export const J = {
    x: 4.5,
    z: -161,
    yaw: .35
};

export function Ut(e, t) {
    return t > -79.2 ? 0 : Math.max(Kt(e, t), Gt(e, t))
}
export const Y = {
    x: 13.4,
    yaw: .5,
    length: 9,
    thick: .8,
    top: 4.2,
    foot: 1.2
};

export function Wt(e, t) {
    let n = -79.2 - t;
    return Math.abs(e) - (Y.x + Math.max(0, n) * Math.tan(Y.yaw))
}

export function Gt(e, t) {
    let n = t - -78;
    if (n > -1.2) return 7.14 + k(-.2, 6, n) * (.8 + (Ht(e * .18, t * .18) - .5) * .9);
    let r = 7.2 * (1 - k(0, 16, -n - 1.2)),
        i = (Wt(e, t) - Y.thick - .4) * 1.5;
    return E(Math.min(r, i), 0, 7.2)
}

export function Kt(e, t) {
    let n = Ht(e * .045, t * .045) + Ht(e * .11 + 17.3, t * .11 - 4.1) * .45 + Ht(e * .31 - 8.2, t * .31 + 5.7) * .12,
        r = (n - .78) * 2.3;
    r *= k(3.4, 13, Xt(e, t));
    let i = k(24, 52, Math.abs(e)) + k(-162, -196, t);
    return r += i * (4.2 + n * 2.4), r *= k(6, 12, Math.hypot(e - J.x, t - J.z)), r *= 1 - k(-102, -90, t) * (1 - k(16, 26, Math.abs(e))) * .7, r *= k(-79.2, -84, t), r
}

export function qt(e, t, n) {
    if (t < -79.2) return Ut(e, t);
    if (Bt(e, t, K) && n >= K.top - .05) return K.top;
    if (Bt(e, t, G) && n >= G.top - .05) return G.top;
    for (let r of Lt)
        if (Bt(e, t, r) && n >= r.top - .05) return r.top;
    return 0
}

export function Jt(e, t, n, r, i, a) {
    let o = It,
        s = -79.2;
    r < s ? (n = E(n, H.xMin, H.xMax), r = E(r, H.zMin, s), r > -79.52 && Math.abs(n) > U.halfFloor - o && (r = Math.min(r, -79.52))) : r < U.zEnd + .3 ? (t < s && Math.abs(n) > U.halfFloor - o && (r = -79.52), n = E(n, -(U.halfFloor - o), U.halfFloor - o)) : (n = E(n, W.xMin + .4 + o, W.xMax - .4 - o), r = E(r, W.zMin + .3, W.zMax - .4 - o), t < U.zEnd + .3 && Math.abs(n) > U.halfFloor - o && (n = E(n, -(U.halfFloor - o), U.halfFloor - o)));
    for (let a of [...Lt, G])
        if (!(i >= a.top - .05) && Bt(n, r, a, o)) {
            if (Bt(e, t, a, o)) {
                Yt(a, n, r, o).depth > Yt(a, e, t, o).depth && (n = e, r = t);
                let i = Yt(a, n, r, o),
                    s = Math.min(.012, i.depth);
                n += i.dx * s, r += i.dz * s
            } else Bt(e, r, a, o) ? (Bt(n, t, a, o) && (n = e), r = t) : n = e
        } for (let e of [...Pt, ...a]) {
        let t = n - e.x,
            i = r - e.z,
            a = e.r + o,
            s = t * t + i * i;
        if (s < a * a && s > 1e-8) {
            let o = Math.sqrt(s);
            n = e.x + t / o * a, r = e.z + i / o * a
        }
    }
    return [n, r]
}

export function Yt(e, t, n, r) {
    return [{
        depth: t - (e.xMin - r),
        dx: -1,
        dz: 0
    }, {
        depth: e.xMax + r - t,
        dx: 1,
        dz: 0
    }, {
        depth: n - (e.zMin - r),
        dx: 0,
        dz: -1
    }, {
        depth: e.zMax + r - n,
        dx: 0,
        dz: 1
    }].reduce((e, t) => t.depth < e.depth ? t : e)
}

export function Xt(e, t) {
    let n = 1 / 0;
    for (let r = 0; r < q.length - 1; r++) {
        let [i, a] = q[r], [o, s] = q[r + 1], c = o - i, l = s - a, u = E(((e - i) * c + (t - a) * l) / (c * c + l * l), 0, 1), d = i + c * u - e, f = a + l * u - t;
        n = Math.min(n, d * d + f * f)
    }
    return Math.sqrt(n)
}

export const SPAWN_FOREST = At;
export const SPAWN_PIPE_MOUTH = jt;
export const FOREST = H;
export const PIPE = U;
export const CLUB = W;
export { Rt as zoneAt, zt as zoneVis };
